import Swiper, { Navigation, Autoplay } from 'swiper'

const SliderIcons = () => {
  const swiper = new Swiper('.slider-icons-component', {
    modules: [Autoplay, Navigation],
    
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: true,
    spaceBetween: 31,
        
    autoplay: {
      delay: 3300,
      disableOnInteraction: false,
    },

    navigation: {
      nextEl: '.slider-icons .slider-button-next, .header-component .slider-button-next',
      prevEl: '.slider-icons .slider-button-prev, .header-component .slider-button-prev',
    },

    breakpoints: {
      768: {
        centeredSlides: false,
      },      
    },

    on: {
      beforeResize: function (s) {
        let sHeight = s.height
        let parent = s.$el.closest('[data-component=slider-cards-icons]')
        parent[0].style.height = sHeight+120 + 'px';        
      },
    }
  })


}

export default SliderIcons
